(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/animations/viking-whitty-numbers.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/animations/viking-whitty-numbers.js');


'use strict';

function animateBackground() {
  let isResized = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const container = document.querySelector('.number-games-content');
  const board = document.querySelector('.numbergames-play-content');
  const containerRect = container.getBoundingClientRect();
  const containerTop = container.offsetTop;
  const whittyNumbers = gsap.utils.shuffle(gsap.utils.toArray('.whitty-number') || []);
  const total = whittyNumbers.length;
  const isLandscape = window.innerWidth > window.innerHeight;
  const height = isLandscape ? containerRect.height : containerRect.width;
  const columns = isLandscape ? 4 : 2;
  const rows = Math.ceil(total / columns);
  const cellWidth = (containerRect.width + (isLandscape ? height * 0.5 : 0)) / columns;
  const cellHeight = (containerRect.height + (isLandscape ? 0 : height * 0.5)) / rows;
  whittyNumbers.forEach((el, index) => {
    const col = index % columns;
    const row = Math.floor(index / columns);
    const jitterX = Math.round((Math.random() - 0.5) * cellWidth * 0.4);
    const jitterY = Math.round((Math.random() - 0.5) * cellHeight * 0.4);
    const left = Math.round(col * cellWidth - height * 0.125 + jitterX);
    const top = Math.round(row * cellHeight - height * 0.125 + jitterY);
    const startRotation = Math.random() * 160 - 80;
    const rotationDrift = Math.random() * 60 - 30;
    const minHeight = Math.min(height * 0.8, 600);
    el.style.position = 'absolute';
    el.style.height = "".concat(minHeight, "px");
    el.style.width = "".concat(minHeight, "px");
    el.style.left = "".concat(left, "px");
    el.style.top = "".concat(top, "px");
    el.style.opacity = 1;
    const elementTopInDocument = containerTop + top;
    const dropStartY = containerTop - 100 - height - elementTopInDocument;
    const dropStartX = (Math.random() - 0.5) * 3 * height;
    if (!isResized) {
      gsap.set(el, {
        y: dropStartY,
        x: dropStartX,
        rotation: 0
      });
    }
    const tlNumber = gsap.timeline({
      delay: index * 0.1
    });
    tlNumber.to(el, {
      y: 0,
      x: 0,
      rotation: startRotation + rotationDrift,
      duration: 1,
      ease: 'backo.out(1)'
    }, '>');
  });
  if (!isResized) {
    gsap.set(board, {
      opacity: 0
    });
    gsap.to(board, {
      opacity: 1,
      delay: 1.5,
      duration: 1
    });
  }
}
svs.numbergames.game.animations.vikingWhittyNumbers = {
  animateBackground
};

 })(window);